module.exports = __webpack_public_path__ + "css/OceanVolt.c6144bc3.css";